<template>
  <div class="mainPages">
    <div class="topNav">
      <div class="navLeft">
        <el-input class="searchInput"
                  placeholder="请输入视频名称"
                  value-format="yyyy-MM-dd"
                  v-model="searchInput"
                  :blur="searchInputChange(searchInput)"
                  prefix-icon="el-icon-search"
                  :clearable="true">
        </el-input>

        <el-button class="searchBtn" type="danger" @click="getSearch(1)">搜索</el-button>

      </div>
      <div class="navRight">
        <el-button class="refreshBtn" icon="el-icon-refresh" @click="getSearch(1)" circle></el-button>
      </div>
    </div>

    <div class="mainForm">
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        border
        highlight-current-row
        class="previous-row"
        @current-change="handleCurrentChange"
        :header-cell-style="{backgroundImage:'linear-gradient(#f9f9f9,#f9f9f9)',color:'#909399',textAlign:'center'}"
        :data="videoList"
      >
        <el-table-column type="index" label="序号" class="indexCenter" width="80"></el-table-column>
        <el-table-column property="name" label="视频名称"></el-table-column>
        <el-table-column property="durationStr" label="时长"></el-table-column>
        
        <el-table-column
          class="optionList"
          fixed="right"
          label="操作"
          width="160">
          <!--使用slot-scope传递当前行参数-->
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="detail(scope.row)">播放教程
            </el-button>
          </template>

        </el-table-column>
      </el-table>
    </div>

    
    <page-helper ref="pageHelper" :list="getSearch" @pageSizeChange="reSearch" :totalSize="totalSize" :page="current" :size="size" :showGo="true"></page-helper>
    <!-- 添加 VideoPlayer 组件的使用 -->
    <video-player ref="videoPlayer"></video-player>
  </div>
</template>

<script>
import PageHelper from '../../../components/PageHelper'
import VideoPlayer from '../../../components/VideoPlayer'  // 引入 VideoPlayer 组件

export default {
  name: 'Video',
  components: {
    PageHelper,
    VideoPlayer,  // 注册 VideoPlayer 组件
  },
  data () {
    return {
      message: '视频教程',
      searchInput: '',//搜索内容
      videoName: '',//视频名称
      currentRow: null,//当前行
      totalSize: 0,
      current: 1,
      size: 10,
      videoList: []
    };
  },
  mounted () {
    this.getSearch();
    
  },
  methods: {
    //1.搜索
    searchInputChange(searchInput) {
      // 更新videoName数据属性
      this.videoName = searchInput;
      //console.log('搜索内容: ', searchInput)
    },

    async getSearch(page, pageChange) {
      Loadings.show();//加载框
      let current = page || 1;//当前页
      let size = this.$refs.pageHelper.size || 10; //10
      
      // let keywords = this.searchInput;//搜索内容
      // console.log('请求参数:', { name: keywords, current, size }); // 添加日志
      // 使用this.videoName作为搜索关键词
      //console.log('请求参数:', { name: this.videoName, current, size }) // 添加日志

      try {
        this.$axios.get(process.env.VUE_APP_SERVER + '/blade-video-tutorial/list?name=' + this.videoName + '&current=' + current + '&size=' + size)
            .then((res) => {
              //console.log(res)
              if (res && res.data.code === 200) {
                this.videoList = res.data.data.page.records || [];
                //console.log(this.videoList);
                this.totalSize  = res.data.data.page.total || 0;
                this.current = res.data.data.page.current || 1;
                this.size = res.data.data.page.size || 10;
                // 更新分页组件
                this.$refs.pageHelper.render(this.current, this.totalSize);
              } else {
                console.warn('接口返回非 200:', res)
              }  
          })
        } catch (error) {
          console.error('请求出错:', error) // 打印完整错误信息
        } finally {
          Loadings.hide()
        }
      },
    
    reSearch(data) {//搜索
      // 搜索时使用当前的searchInput值
      this.getSearch(1, data);//获取列表
    },
    
    handleCurrentChange(val) {//当前页切换
      this.currentRow = val;//当前行
    },
    // 弹框
    detail(row) {
      // 直接使用 row.path 和 row.name 显示视频
      this.$nextTick(() => {
        this.$refs.videoPlayer.openDialog(row.path, row.name);
      });
    }
  }
};
</script>

<style scoped>

.mainPages {
  /*min-height: 850px;
  height: calc(100vh - 120px);*/
  overflow: hidden;
}

/*顶部导航*/
.pageNav {
  display: inline-block;
  float: left;
  position: relative;
  margin-bottom: 20px;
  margin-top: 10px;
}


.videoName {
  margin-top: -5px;
  font-size: 16px;
  line-height: 40px;
  text-decoration: none;
}

/*搜索导航*/
.topNav {
  width: 100%;
  display: inline-block;
  margin-top: 10px;
}

.navLeft {
  float: left;
}

.searchInput {
  width: 250px;
  float: left;
  margin-right: 10px;
}

.searchBtn {
  margin-right: 10px;
  float: left;
}


.navRight {
  float: right;
}

.refreshBtn {
  color: #e92322;
  font-weight: bold;
  margin-right: 50px;
}

/*表格*/
.mainForm {

}

/deep/ .el-table .el-table__cell:first-of-type {
  line-height: 30px !important;
}

/deep/ .el-table .el-table__cell:first-child {
  text-align: center;
}

/deep/ .el-table__body-wrapper {
  min-height: 600px;
}


</style>